module.exports = __webpack_public_path__ + "static/media/ww_hidr2.ac217819.gif";